import service from '../services/request'

// 获取问卷列表
export const getQueList = function (params) {
  return service({
    method: 'get',
    url: '/questionnaire/getQuestionnaire',
    params
  })
}
// 获取问卷详情
export const getQueDetail = function (params) {
  return service({
    method: 'get',
    url: '/questionnaire/getQuestionnaireDetail',
    params
  })
}

// 获取引导页详情
export const getGuide = function (params) {
  return service({
    method: 'get',
    url: '/guide/getGuidebyId',
    params
  })
}